import styled from 'styled-components';
import { ReactComponent as ErrorIcon } from 'assets/images/cross-circle.svg';
import { ReactComponent as SuccessIcon } from 'assets/images/success-circle.svg';
import { ReactComponent as DismissIcon } from 'assets/images/cross-icon.svg';
import MOText from 'common/components/atoms/MOText';

const StyledToast = styled.div`
  position: relative;
  display: flex;
  max-width: 500px;
  padding: 16px 56px 16px 48px;
  background: #FFF;

  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.secondaryColor[4]};

  &:not(:last-child) { margin-bottom: 8px; }
  & .icon {
    position: absolute;
    top: 17px;
    left: 17px;
  }

  &.success, &.error {
    border-color: transparent;
    & .dismiss svg path {
      stroke: #fff;
    }
  }

  &.success {
    background: ${({ theme }) => theme.primaryColor[6]};
  }

  &.error {
    background: #DC2626;
  }

  &.default {
    padding: 16px 56px 16px 16px;
  }

  &.toast-enter {
    transform: translateX(calc(100% + 16px));
  }

  &.toast-enter-active {
    transform: translateX(0);
    transition: transform 500ms;
  }

  &.toast-exit {
    transform: translateX(0);
  }

  &.toast-exit-active {
    transform: translateX(calc(100% + 16px));
    transition: transform 500ms;
  }
`;

const StyledCloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 12px;
  padding: 6px;
  cursor: pointer;
`

const StyledText = styled(MOText)`
  &.success, &.error { color: #FFF; }
`;

interface IToast {
  text?: string;
  variant?: 'default' | 'error' | 'success';
  onDismiss?: () => void;
}

const Toast:React.FC<IToast> = ({
  text = '',
  variant = 'error',
  onDismiss = () => null,
}) => (
  <StyledToast className={variant}>
    {variant === 'success' && (
      <SuccessIcon className="icon" />
    )}
    {variant === 'error' && (
      <ErrorIcon className="icon" />
    )}
    <StyledText
      typographyStyle="body2Bold"
      className={variant}
    >
      {text}
    </StyledText>
    <StyledCloseButton
      onClick={onDismiss}
      className={`dismiss ${variant}`}
    >
      <DismissIcon />
    </StyledCloseButton>
  </StyledToast>
);

export default Toast;
